import React, { useState, useEffect } from 'react';
import '../App.css';
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import { Button, Container, Row, Col } from 'react-bootstrap';
//import Navbar from "./Navbar_vecchio";
import { propTypes } from 'react-bootstrap/esm/Image';
import JSONPretty from 'react-json-pretty';
import { useAuth0 } from "@auth0/auth0-react";
import Seleziona_la_classe from "./Alunno_x3_seleziona_classe.jsx";
import Nuovo_Progetto from "./Progetto_x5_nuovo_progetto.jsx";
import Tabella_Lista_alunni from "./Pr_x8_lista_alunni.jsx";
import Lista_Progetti from "./Progetto_x6_lista_progetti.jsx";

function check_variabili_oggetto(obj, ...args) {
    return args.reduce((obj, level) => obj && obj[level], obj)
}


const Progetto = (props) => {
    const [lista_ditte, SET_lista_ditte] = useState([]);
    const [lista_alunni, SET_lista_alunni] = useState([]);
    const [lista_progetti, SET_lista_progetti] = useState([]);
    const [variab_aggiorna, SET_variab_aggiorna] = useState(false);
    const [lista_classi, SET_lista_classi] = useState([]);
    const [tutor, SET_tutor] = useState('');
    const [classe_selezionata, SET_classe_selezionata] = useState();
    const [classe_selezionata_item, SET_classe_selezionata_item] = useState({});

    const [start_Date, set_Start_Date] = useState(new Date());
    const [end_Date, set_End_Date] = useState(new Date());
    const { user, isAuthenticated } = useAuth0();



    useEffect(() => {

        let classe_item = {}
        classe_item = lista_classi.find(element => element._id == classe_selezionata);
        console.log(classe_item) 

        let livello_formazione = 0 
        if (classe_item != undefined && classe_item.nome.includes('5')) {livello_formazione = 3}
        if (classe_item != undefined && classe_item.nome.includes('4')) {livello_formazione = 3}
        if (classe_item != undefined && classe_item.nome.includes('3')) {livello_formazione = 2}
        if (classe_item != undefined && classe_item.nome.includes('2')) {livello_formazione = 1}

        if (classe_item != undefined) {classe_item.livello_formazione = livello_formazione}          

        SET_classe_selezionata_item(classe_item)         
       
       
    }, [classe_selezionata]);

    

    useEffect(() => {
        console.log('dentro Useeffect')
        let btn 
        
        btn = check_variabili_oggetto (user, 'email')
//        console.log(btn)
//        console.log(user)
  
        if (btn !== undefined) { 
            Controlla_se_esiste_Account()
        }
        if (user != undefined) {
       
            Carica_alunni_x_account()
        }
//        Carica_progetti_esistenti_per_classe()
//        Carica_progetti_esistenti()
    }, [variab_aggiorna, classe_selezionata, user]);



    const Carica_alunni_x_account = () => {
        //    funzione_set_aggiornamento(true)
        console.log('Carica_domande_x_account')
        let end_date = 5
        var utente = 'utente_unico'
        const parametro_cestino = 0
        //        https://mydomain.dm/fruit/{"name":"My fruit name", "color":"The color of the fruit"}
        axios.get('/alunni/alunni2/' + utente + '/' + classe_selezionata 
                                                            + '/' + user.email + '/' + parametro_cestino)
            .then((res) => {
//                console.log('ALUNNI appena fecciate da mongo')
//                console.log(res.data)

                SET_lista_alunni(res.data)
                if (user != undefined) {
                   Carica_progetti_esistenti_per_alunno (res.data)
                }
            }).catch((error) => {
                console.log('ALUNNI errore')
                console.log(error)
            });
        
    }


    const Carica_alunni_x_account_doppione = (parametro_cestino) => {
        //    funzione_set_aggiornamento(true)
        console.log('Carica_alunni x_account ' + parametro_cestino)
     
        var utente = 'utente_unico'
        //        https://mydomain.dm/fruit/{"name":"My fruit name", "color":"The color of the fruit"}
        console.log('------------------- ' + classe_selezionata)


        axios.get('/alunni/alunni_nuovo/', {
            params: {
                utente: utente,
                classe_selezionata: classe_selezionata,
                email: user.email, 
                cestino: parametro_cestino,
            }
        }).then((res) => {
//                console.log('ALUNNI appena fecciate da mongo')
            console.log(res.data)
            SET_lista_alunni(res.data)
        }).catch((error) => {
            console.log('ALUNNI errore')
            console.log(error)
        });
    }


    const Carica_progetti_esistenti_per_alunno = (lista_alunni) => {
        //    funzione_set_aggiornamento(true)
        let lista_alunni_id = lista_alunni.map(a => a._id);
//        console.log(lista_alunni_id)
        var utente = 'utente_unico'
//         {/* idroslab  viene inviata una lista al server tramite lo stringify*/}

        axios.get('/progetti/progetto_carica_per_alunni_selezionati/', {
            params: {
                id_utente: 'utente_unico',
                lista_alunni_id: JSON.stringify(lista_alunni_id),
                email: user.email
            }
            }) 
            .then((res) => {
//                console.log('DDDDD progetti fecciati da mongo')
                SET_lista_progetti(res.data)
                //                console.log(res.data)

            }).catch((error) => {
                console.log(error)
            });
    }


    const Controlla_se_esiste_Account = () => {
        //    funzione_set_aggiornamento(true)
        console.log('XXXXXXXXXXXXXXX Carica_tutor_x_account')
        console.log(user.email)
     
        let end_date = 5
        var utente = 'utente_unico'
        //        https://mydomain.dm/fruit/{"name":"My fruit name", "color":"The color of the fruit"}
        
        axios.get('/tutor/cerca1/' + user.email)
            .then((res) => {
//                console.log('un TUTOR appena fecciato da mongo')
//                console.log(res.data)
//                console.log(check_variabili_oggetto (res.data[0], '_id'))
                Carica_classi_x_account(check_variabili_oggetto (res.data[0], '_id'))
                SET_tutor(res.data[0])
//                console.log(res.data[0].date_start_progetto)
//                console.log(res.data[0].date_end_progetto)
                let data_start = new Date(res.data[0].date_start_progetto)
                let data_end = new Date(res.data[0].date_end_progetto)
                set_Start_Date(data_start)
                set_End_Date(data_end)
                SET_classe_selezionata(res.data[0].ultima_classe_selezionata)
            }).catch((error) => {
                console.log(error)
            });
    }


    const Carica_classi_x_account = (_id) => {
        //    funzione_set_aggiornamento(true)
        console.log('Carica_domande_x_account')
        let end_date = 5
        var utente = 'utente_unico'
        //        https://mydomain.dm/fruit/{"name":"My fruit name", "color":"The color of the fruit"}

        axios.get('/classi/classi5/' + utente + '/' + _id)
            .then((res) => {
//                console.log('CLASSI X TUTOR appena fecciate da mongo')
//                console.log(res.data)
                if (Array.isArray(res.data) && res.data.length > 0) {SET_lista_classi(res.data)}
            }).catch((error) => {
                console.log(error)
            });
    }




    const Carica_progetti_esistenti = () => {
        //    funzione_set_aggiornamento(true)
        console.log('')
        var utente = 'utente_unico'

        axios.get('/progetti/progetto_carica_tutti/' + utente)
            .then((res) => {
                console.log('progetti fecciati da mongo')
                SET_lista_progetti(res.data)
                //                console.log(res.data)

            }).catch((error) => {
                console.log(error)
            });
    }


    return (
        <Container fluid="xxl">
             

            {(props.account_dati.utente_debug) &&
        
                <JSONPretty data={user} />
            }
            {(props.account_dati.utente_debug) &&

                <JSONPretty data={tutor} />
            }
            <div className= 'd-flex flex-row-reverse'>
                
                <Seleziona_la_classe    lista_classi={lista_classi} 
                                        SET_classe_selezionata ={SET_classe_selezionata}
                                        classe_selezionata={classe_selezionata} 
                                        tutor ={tutor} />
                
            </div>
            <div className= 'd-flex flex-row-reverse'>
                <p>{check_variabili_oggetto (tutor, 'email')}</p>
            </div>
            <Container fluid="xxl">
                <Row>
                <Col md="auto">
                    <Tabella_Lista_alunni lista_alunni={lista_alunni} tutor={tutor} classe_selezionata= {classe_selezionata}/> 

                </Col>
                <Col>
                    <Nuovo_Progetto start_Date={start_Date}
                                    lista_progetti={lista_progetti} 
                                    lista_alunni={lista_alunni}
                                    end_Date={end_Date} 
                                    SET_variab_aggiorna={SET_variab_aggiorna}
                                    tutor={tutor}
                                    classe_selezionata= {classe_selezionata}
                                    set_Start_Date = {set_Start_Date}
                                    set_End_Date = {set_End_Date}
                                    account_dati={props.account_dati}
                                    />
                    <Lista_Progetti lista_progetti={lista_progetti} 
                            lista_alunni={lista_alunni}
                            tutor = {tutor} 
                            classe_selezionata_item = {classe_selezionata_item}
                       
                            SET_variab_aggiorna={SET_variab_aggiorna} 
                            account_dati={props.account_dati}/> 
                </Col> 
          
                </Row>
            </Container>
            
 
        </Container>
    )
}

export default Progetto;
